const GA_MEASUREMENT_ID = "G-426G2J9D0Q";
const PRODUCTION_HOSTNAMES = new Set(["sondharct.com", "www.sondharct.com"]);
const SCRIPT_ID = "google-analytics";

function isProductionSite() {
  return (
    typeof window !== "undefined" &&
    PRODUCTION_HOSTNAMES.has(window.location.hostname)
  );
}

export function initializeAnalytics() {
  if (!isProductionSite() || document.getElementById(SCRIPT_ID)) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, {
    send_page_view: false,
  });

  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
}

export function trackPageView() {
  if (!isProductionSite()) return;

  initializeAnalytics();
  window.gtag("event", "page_view", {
    page_location: window.location.href,
    page_path: `${window.location.pathname}${window.location.search}`,
    page_title: document.title,
  });
}

export function trackEvent(eventName, parameters = {}) {
  if (!isProductionSite()) return;

  initializeAnalytics();
  window.gtag("event", eventName, parameters);
}
